import React from 'react';
import PropTypes from 'prop-types';

import { Select } from 'spicecomponents';

const BreakAnswer = (props) => {
  const {
    cdf,
    controlList,

    value,
    onChange,
  } = props;

  const getSurvey = () => {
    const survey = cdf.Survey;
    if (!survey || survey.length > 1) {
      return 'AllSurveys';
    }
    return survey[0];
  };

  const options = (() => {
    const breakGroup = controlList.Options[getSurvey()].filter((g) =>
      Object.keys(g)[0] === props.breakGroup
    )[0];

    if (breakGroup) {
      const breakAnswers = breakGroup[Object.keys(breakGroup)].BreakAnswers;
      return breakAnswers.map((a) => {
        const label = Object.keys(a)[0];
        return { value: label };
      });
    }
    return [];
  })();

  return (
    <div>
      <label htmlFor="breakAnswer">Select Customer Sub-group</label>
      <Select name="breakAnswer" placeholder="None" options={options} onChange={onChange} value={value || null} />
    </div>
  );
};

BreakAnswer.propTypes = {
  cdf: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string,
  controlList: PropTypes.object,
};

export default BreakAnswer;



// WEBPACK FOOTER //
// ./app/components/FormControls/BreakGroup_BreakAnswer/BreakAnswer.js